<template functional>
  <span>
    {{ $options.competitionNames(props.value) }}
  </span>
</template>
<script>
import gql from "fraql";
import { sortBy } from "lodash-es";
export default {
  name: "AppShowCompetitionLevelNames",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  competitionNames(v) {
    return sortBy(v.filter(Boolean), "rank")
      .map(level => level.name)
      .join(", ");
  },
  fragments: {
    competitionLevel: gql`
      fragment _ on CompetitionLevel {
        id
        name
        nameTranslations {
          value
          locale
        }
        rank
      }
    `,
    competitionLevels: gql`
      fragment _ on Event {
        competitionLevels {
          id
          name
          nameTranslations {
            value
            locale
          }
          rank
        }
      }
    `
  }
};
</script>
